import { inject, Injectable } from '@angular/core';
import { SessionStorageService } from '../../../../core/services/session-storage/session-storage.service';
import { environment } from '../../../../../environments/environment';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';

@Injectable({
  providedIn: 'root'
})
export class DashboardManagerTeamServiceV2 {

  private sessionStorageService = inject(SessionStorageService);

  constructor() { }

  async getDashboardInceptedApeDirectorwiseManager(targetYear: number) {
    const API_URL: string = environment.baseUrl + environment.apis.dashboardNewApeDirectorwiseManagers;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        "repcode": this.sessionStorageService.getCurrentRepCode(),
        "ReportYear": targetYear
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });

  }

  async getDashboardInceptedApeManagerwiseAdvisors(managerRepCode: string) {
    const API_URL: string = environment.baseUrl + environment.apis.dashboardNewApeManagerwiseAdvisors;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        "repcode": managerRepCode
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });

  }

  async getAgentsByPiasId(managerRepCode: string, targetYear: number) {
    const API_URL: string = environment.baseUrl + environment.apis.NewgetAgentsByPiasId;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        "repcode": managerRepCode,
        "reportyear": targetYear
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });

  }

  async getDashboardGrossRevenueDirectorwiseManager(targetYear: number) {
    const API_URL: string = environment.baseUrl + environment.apis.dashboardNewGrossRevenueDirectorwiseManagers;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        "repcode": this.sessionStorageService.getCurrentRepCode(),
        "reportYear": targetYear
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });

  }

  async getDashboardGrossRevenueManagerwiseAdvisors(managerRepCode: string, targetYear: number) {
    const API_URL: string = environment.baseUrl + environment.apis.dashboardNewGrossRevenueManagerwiseAdvisors;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        "repcode": managerRepCode,
        "reportyear": targetYear
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });

  }

}
